var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-plans"},[_c('Headline'),_c('Plans'),_c('Terms'),_c('NonProfit'),_c('PricingGifts'),_c('SwitchToRss',{staticClass:"switchToRssSection"}),_c('Reviews',{attrs:{"decoration":false}}),_c('Rating',{attrs:{"containerized":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }